import { render, staticRenderFns } from "./IconUserCircleSolid.vue?vue&type=template&id=c38df0a4"
import script from "./IconUserCircleSolid.vue?vue&type=script&lang=js"
export * from "./IconUserCircleSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports